import { Dispatch, SetStateAction } from 'react';
import { Checkbox } from '@Components/FormCheck';
import { Appearance, Size } from '@Components/designConstants';
import '@Pages/GeoMMM/Results/Components/FilterCheckbox.scss';
import { Button } from '@Components/Button';

interface FilterCheckboxProps {
  filterOptions: string[];
  segments: string[];
  selectedSegments: string[];
  setSelectedSegments: Dispatch<SetStateAction<string[]>>;
}

export const FilterCheckbox = ({
  filterOptions,
  segments,
  selectedSegments,
  setSelectedSegments
}: FilterCheckboxProps) => {
  const toggleSegment = (segment: string) => {
    setSelectedSegments((prev: string[]) =>
      prev.includes(segment) ? prev.filter(s => s !== segment) : [...prev, segment]
    );
  };

  const selectAll = () => {
    setSelectedSegments(filterOptions.filter(option => option !== 'Linear TV'));
  };

  const clear = () => {
    setSelectedSegments([]);
  };

  return (
    <div className='filter-checkbox-container'>
      <div className='filter-header'>
        <Button appearance={Appearance.EMPTY} size={Size.SM} onClick={() => selectAll()}>
          Select All
        </Button>
        <Button appearance={Appearance.EMPTY} size={Size.SM} onClick={() => clear()}>
          Clear
        </Button>
      </div>
      <div className='filter-options'>
        {segments.map(segment => (
          <Checkbox
            key={segment}
            className='filter-option'
            id={`filter-checkbox-${segment}`}
            label={segment}
            checked={selectedSegments.includes(segment)}
            onChange={() => toggleSegment(segment)}
          />
        ))}
      </div>
    </div>
  );
};
